export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6575.72172a09.jpg";